<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Select stream type</div>
    <div class="modal-body">
      @for (streamType of STREAM_TYPES; track streamType) {
        <div class="form-check" aria-label="Select Stream Type"
          >
          <input type="radio" class="form-check-input" id="radio{{streamType}}" name="type"  [value]="streamType" [(ngModel)]="selectedStreamType">
          <label class="form-check-label" for="radio{{streamType}}">{{ streamType }}</label>
        </div>
      }
    </div>
    <div class="modal-footer">
      <span class="modal-footer-left cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-secondary it-cancel" (click)="dialogRef.close()">
          <span>Cancel</span>
        </button>
      </span>
      <span class="modal-footer-right cl-spacing-box cl-spacing-none">
        <button class="btn cl-color-primary" (click)="dialogRef.close(selectedStreamType)">
          <span>Select</span>
        </button>
      </span>
    </div>
  </div>
</div>
